import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// CART
import { IconsComponent } from './icons/icons.component';

const declarationsAndExports = [IconsComponent];

@NgModule({
  imports: [CommonModule],
  declarations: [...declarationsAndExports],
  exports: [...declarationsAndExports],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SvgModule {}
